// FV Upsell Script V2 (Fixed)
console.log('FV Upsell V2 Loading...');

// Helper: Injects the upsell section into the cart drawer
function fvEnsureUpsellInjection(upsellHTML) {
  const cartDrawerContent =
    document.querySelector('.cart-drawer__content') ||
    document.querySelector('cart-drawer-component');

  if (!cartDrawerContent) return;

  const insert = () => {
    let upsellContainer = cartDrawerContent.querySelector('.fv-cart-upsell-container');
    if (!upsellContainer) {
      upsellContainer = document.createElement('div');
      upsellContainer.className = 'fv-cart-upsell-container';
      cartDrawerContent.appendChild(upsellContainer);
    }
    if (upsellContainer.innerHTML !== upsellHTML) {
      upsellContainer.innerHTML = upsellHTML;
    }
  };

  insert();

  const observerTarget =
    document.querySelector('cart-drawer-component') ||
    document.querySelector('#cart-drawer');

  if (observerTarget) {
    if (window.fvUpsellObserver) window.fvUpsellObserver.disconnect();

    window.fvUpsellObserver = new MutationObserver(() => {
      if (!cartDrawerContent.querySelector('.fv-cart-upsell-container')) {
        insert();
      }
    });

    window.fvUpsellObserver.observe(observerTarget, { childList: true, subtree: true });

    setTimeout(() => {
      if (window.fvUpsellObserver) {
        window.fvUpsellObserver.disconnect();
        window.fvUpsellObserver = null;
      }
    }, 5000);
  }
}

// Logic: Universal Handler
window.fvAddUpsell = function (element) {
  if (!element) return;

  let trigger = element;
  let wrapper = null;
  let variantId = null;

  if (element.tagName === 'FORM') {
    wrapper = element;
    trigger = element.querySelector('button, input[type="submit"]');
    variantId = new FormData(element).get('id');
  } else {
    trigger = element;
    wrapper = element.closest('form');
    variantId = trigger.dataset.variantId;
    if (!variantId && wrapper) {
      variantId = new FormData(wrapper).get('id');
    }
  }

  if (!variantId) {
    console.error('[FV Upsell] Could not find variant ID', element);
    return;
  }

  const originalText = trigger.innerText;
  trigger.innerText = '...';
  trigger.disabled = true;

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  const cartDrawer = document.querySelector('cart-drawer-component');
  const sectionsToUpdate = [];

  const cartComponent = document.querySelector('cart-items-component');
  if (cartComponent && cartComponent.dataset.sectionId) {
    sectionsToUpdate.push(cartComponent.dataset.sectionId);
  }

  if (sectionsToUpdate.length === 0) {
    if (document.getElementById('cart-drawer')) sectionsToUpdate.push('cart-drawer');
    if (document.getElementById('main-cart-items')) sectionsToUpdate.push('main-cart-items');
  }

  sectionsToUpdate.push('fv-cart-upsell-section');
  formData.append('sections', sectionsToUpdate.join(','));
  formData.append('sections_url', window.location.pathname);

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    }
  })
    .then(res => {
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
    })
    .then(data => {
      console.log('[FV Upsell] Added successfully:', data);

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'fv-cart-upsell',
          data: {
            source: 'product-form-component',
            variantId: variantId,
            itemCount: 1,
            sections: data.sections
          }
        }
      }));

      document.dispatchEvent(new CustomEvent('cart-update', {
        bubbles: true,
        detail: { cart: data }
      }));

      if (data.sections && data.sections['fv-cart-upsell-section']) {
        fvEnsureUpsellInjection(data.sections['fv-cart-upsell-section']);
      }

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.showDialog === 'function') drawer.showDialog();
        else if (typeof drawer.open === 'function') drawer.open();
      }

      trigger.innerText = 'Added!';
      setTimeout(() => {
        trigger.innerText = originalText;
        trigger.disabled = false;
      }, 1500);
    })
    .catch(err => {
      console.error('[FV Upsell] Add Error:', err);
      trigger.innerText = 'Error';
      trigger.disabled = false;
    });
};

// Global delegation listeners
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.fv-test-btn');
  if (btn) {
    e.preventDefault();
    e.stopPropagation();
    window.fvAddUpsell(btn);
  }
}, true);

document.addEventListener('submit', function (e) {
  if (e.target && e.target.classList.contains('fv-upsell-form')) {
    e.preventDefault();
    e.stopPropagation();
    window.fvAddUpsell(e.target);
  }
}, true);

console.log('[FV Upsell] V2 Fixed + Loaded.');
